
<!--  https://www.tiny.cloud/docs/integrations/vue/ -->
<Editor
  ref="ref_tiny"
  v-bind="$attrs"
  v-on="$listeners"
  api-key="7jrk6yn23rjkqw97fnzsnqwr1skdb81a67tkxym4uon1yiki"
  :init="myInit"
/>
